export default {
  /*按钮*/
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload",
    enable:"enable",
    disable:"disable",
    close:"close",
    view:"view",
    confirm:"confirm",
    batchUpdateSwitchCode:"Batch Update Switch Code",
    batchUpdateStatus:"Batch Update Status",
    approved:"approved",
    cancel:"cancel",
    copy:"copy",
    isStop:"Are you sure you want to disable?",
    isEnable:"Are you sure you want to enable?",
    isStopRepeat:"Enable task repetition?",
    isEnablepRepeat:"Disable task repetition?",
    logout:"logout",
    unlock:"unlock",
     redo:"redo",
     back:"back"
  },
  /*Public field or tool function field*/
  common:{
    startTime: "Start Time",
    endTime: "End Time",
    creator: "Creator",
    updater: "Updater",
    createTime: "Create Time",
    updateTime: "Update Time",
    phone:"Mobile Number",
    name:"Name",
    email:"Email",
    idNumber: "ID Number",
    status:"Status",
    remark: "Remarks",
  },
  /*User tracking page*/
  kscore:{
    month: "Number of active periods",
    profit: "Profit",
    detail:"Details",
    symbol:'tradeConfig name',
    direction:'Buying and selling direction',
    openPrice:'Opening price',
    closePrice:'Close price',
    createTime:'Close time',
  },
  registerLog:{
    dataType: "Data Type",
    driverType: "Device Type",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    ipAddress: "IP Location",
    href:"Source URL",
    referrer: "Landing Page",
    directPhone: "referrer's mobile phone number",
    phonePre: "Phone Area Code",
    title:"Gender",
    businessType: "Business Group",
    ruleId: "SMS rule id",
    register:"Original Customer List",
  },
  accountReward:{
    activeId: "Activity ID",
    activeStatus: "Active Status",
    activeName: "Activity Name",
    activeType: "Activity Type",
    proposalNo: "Proposal Number",
    beginDate: "Activity start time",
    endDate: "Activity end time",
    expDay: "Validity Period",
    proposalUser: "Proposer",
    proposalDate: "Proposal Time",
    approvalUser: "Approval Person",
    approvalDate: "Approval time",
    proposalType: "Proposal Type",
    proposalStatus: "Proposal Status",
    applyProposal: "Execute Proposal",
    cancelProposal: "Cancel Proposal",
    applySuccess: "Successful execution",
    applyFail: "Execution failed",
    choiceOne: "Please choose a proposal",
    notSatisfiable: "The proposal does not meet the requirements",
    haveCancelledCustomer: "Proposals cannot include deactivated accounts",
    downloadProActivity: "Recommended bonus activity proposal",
    excuteCustomerNumber:'Member Account',
    demo:'Account Type',
    levelType:'Account level',
    mobilePhone:'Phone',
    chineseName:'Name',
    directPhone:'Direct referrer',
    directindirect:'Direct/indirect referrer',
    indirectPhone:'Indirect Referrer',
    symbolType:'Product Type',
    execVolume:'Number of transactions',
    complianceExecVolume:'Customer trading lots/compliant lots',
    complianceStatus:'Compliance status',
    ctime:'Time to reach standard',
    userCreateDate:'Account opening time',
    activeTime:'Activation time',
    downloadEffectiveCustomer:'Effective Customer Record',
    downloadActivity:'Trading rebate activity',
    downloadActivity0:'Recommended bonus activity',
  },
  rewardTradeDetails:{
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement account phone number',
    currentChineseName:'settlement account name',
    excuteCustomerNumber:'Customer trading account number',
    mobilePhone:'Customer Mobile Number',
    demo:'Account Type',
    levelType:'Account level',
    symbolType:'Product Type',
    symbol:'Product',
    orderid:'position number',
    execVolume:'Number of transactions',
    relationType:'reward type',
    directPhone:'Direct referrer',
    indirectPhone:'Indirect Referrer',
    currentRebete:'Amount',
    ctime:'Settlement time',
    downloadTradeDetails:'Reward Details Record',
    depositStatus:'Deposit Status'
  },
  rewardDealList:{
    createDate:'Settlement time',
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement mobile phone number',
    currentChineseName:'settlement customer name',
    customerStatus:'Account Status',
    accountStatusCode:'Account Status',
    currentRebete:'Reward amount',
    correctionRebete:'Adjustment amount',
    finalRebete:'Final rebate',
    proposalStatus:'Status',
    updateUser:'modified person',
    updateDate:'modification time',
    approvalUser:'Approval person',
    approvedDate:'Approval time',
    remark:'Remarks (Rejection Reason)',
    confirmSubmit:'Confirm Submit',
    confirmSuccess: "Submit successfully",
    confirmFail: "Submit failed",
    cancel:'Cancel',
    confirm:'OK',
    cancelProposal:'Cancel Proposal',
    refuse:'Reject the proposal',
    apply:'Approval',
    reason:'reason',
    limit:'Limit adjustment table',
    refuseProposal:'Refuse',
    downloadLimit:'download limit adjustment table'
  },
  relationList:{
    customerRelation:'User recommendation relationship',
    customerRelationPro:'User recommendation relationship proposal',
    customerNum:'transaction account number',
    mobilePhone:'Mobile phone number',
    userName:'Name',
    userLevel:'Account Level',
    createDate:'Account opening date',
    activeTime:'Activation time',
    newdirectPhone:'Direct recommender',
    remark:'Remarks',
    customerNumber:'member account',
    phone:'Phone',
    direct:'Direct/Indirect Referrer',
    matchType:'Recommendation relationship',
    activeStatus:'Activation Status',
    demoCustomerNum:'Analog Account',
    directNumber:'Direct recommender account',
    directPhone:'Directly recommend the person phone',
    indirectNumber:'indirect referrer account',
    indirectPhone:'Indirect referral phone',
    inviteCode:'Invite code',
    useInviteCode:'Invite code exists',
    directInviteCode:'Direct invite code',
    reStatus:'matching result',
    proposalUser:'Proposer',
    proposalDate:'Proposal time',
    approvalUser:'Approval person',
    approvalDate:'Approval time',
    applyProposal: "Execute Proposal",
    cancelProposal:'Cancel Proposal',
    beginDate:'Account opening start time',
    endDate:'Account opening end time',
    proposalStatus:'Proposal Status',
    proposalNo:'Proposal number',
  },
  faceConfig:{
    deleteSuccess:'Delete successfully!',
    updateSuccess:'Modified successfully!',
    code:'channel code',
    name:'channel name',
    type:'Verification Type',
    thirdParty:'Third Party Interface',
    cost:'cost',
    status:'Status',
    remark:'Remarks',
    verifyCode:'Manufacturer Channel',
    verifyType:'Verification Type',
    verifyTypeCN:'Verify Type Chinese',
    describe:'Verify description',
    device:'Platform Type',
    channel:'Channel name',
    channelDesc: 'Channel name，E.g. Android: cf / iOS: com.cfd.cf',
    version:'Version number',
    versionDesc: 'Version number，E.g. Android: 111 / iOS: 1.1.1',
    switchCode:'Channel switch',
    faceStatus:'Face Control',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
    submitSuccess:'Operation successful',
    faceRecord:'Verification Record',
    chineseName:'Name',
    card:'ID',
    phone:'Mobile phone number',
    recordDate:'Record time',
    channelName:'channel name',
    result:'Comparison result',
    resultParam:'Query output',
    count:'Number of uses',
    successCount:'Number of successes',
    artificialCount:'Number of successful manual calls',
    systemCount:'Number of successful system calls',
    needSelectRecord: 'Please select at least one record',
  },
  creditLevel:{
    updateList:'Credit rating modification list',
    journal:'modification log',
    batchImport:'Batch import',
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'Only upload xlsx files, and no more than 10M',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    downTemplate:'Download template',
    uploadFile:'Upload now',
    batchUpdate:'Batch modification',
    customerNo:'Member account',
    pkey:'P tag',
    creditLevelOld:'Credit level before modification',
    creditLevelOriginal:'Current user credit level',
    creditLevel:'Credit Level',
    remark:'Remarks',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
  },
  starLevel:{
    updateList:'Star level modification list',
    journal:'modification log',
    batchImport:'Batch import',
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'Only upload xlsx files, and no more than 10M',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    downTemplate:'Download template',
    uploadFile:'Upload now',
    batchUpdate:'Batch modification',
    customerNo:'Member account',
    starLevelOld:'Star level before modification',
    starLevelOriginal:'Current user star level',
    starLevel:'Star Level',
    remark:'Remarks',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
    update:'Modify ',
    dataType:'Modify Type',
  },
  rebateComponents:{
    subtotal:'Subtotal',
    total:'Total',
    tradeLogList:'Rebate details record details',
    cancel:'Cancel',
    confirm:'Confirm',
    symbolType:'Product Type',
    displayName:'Product',
    orderId:'position number',
    execVolume:'Trading lots',
    rebateAmount:'rebate amount',
    activeName:'active name',
    activity:'activity time',
    activeId:'Activity ID',
    effective:'Effective customer condition setting',
    tips:'New customer account opening and activation time must be within the activity period',
    beginDate: "Start Time",
    endDate: "End Time",
    expDate: "Start Date of Validity Period",
    expDay: "Validity Period",
    productType: "Product Type",
    me: "Customer",
    direct: "Direct Recommendation",
    indirect: "Indirect recommendation",
    quantity: "Trading lot requirements",
    highAmount:'Highest reward amount',
    highAmount2:'New customers highest contribution rebate',
    highPoint:'Customers recommended accumulatively get the highest rebate',
    add:'Add',
    update:'Modify',
    dollar:'dollar',
    day:'day',
    activeTime:'Activation Date',
    reward:'Recommended bonus setting',
    rebate:'Trading rebate settings',
    addCondition:'Add Condition',
    min:'mini',
    std:'standard',
    vip:'Golden Diamond',
    to:'to',
    all:'All',

  },
  risk:{
    name:"Gateway Name",
    baseSetting: "Basic User Configuration",
    specialSetting: "Specific User Configuration",
    ipSetting: "ip rule configuration",
    addBaseSetting: "Add Rule User Group",
    addspecialSetting: "Add a specific user group",
    settingTpye: "Configuration Type",
    userType: "User Group",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    limitSetting: "Limit Rules",
  },
  registervalidate:{
    customerNo: "Account",
    registerType: "Account Opening Type",
    target:"tag",
    creditTunnel2: "Credit Channel 2",
    creditTunnel3: "Credit Channel 3",
    validateStatus2: "Two-element validation status",
    validateStatus3: "Three-element validation status",
    registerStatus: "Account Opening Status",
    channel: "channel source",
    kycResult: "kyc verification result",
    personMarkTunnel: "Credit Investigation Litigation Channel",
    personMarkResult: "Credit Investigation Litigation Verification Result",
    creditLoanTunnel: "Credit Overdue Channel",
    creditLoanResult: "Credit overdue verification result",
  },
  tracker:{
    customerNo: "User Account",
    openStartTime: "Account opening start time",
    openEndTime: "Account opening end time",
    activeStartTime: "Activation start time",
    activeEndTime: "Activation End Time",
    userType: "Account Type",
    isActive: "Activation Status",
    isShow: "Column segment display/hide",
    businessType: "Business Group",
    relatedAccount: "Associated Account",
    levelType: "Account Level",
    userAge: "Age",
    gender:"Gender",
    birthday:"Date of Birth",
    ctime: "Account Opening Date",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    href:"source url",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    activeTime: "Activation Time",
    ipAddress: "IP Location",
    userAgent: "Browser",
    checkStatus: "IVI Verification Status",
    arbitrageurTags: "IVI Verification Tag",
    directAccount:"referrer's account",
    directPhone: "referrer's mobile phone number",
    tracker: "User Tracking",
    inviteCode:'Invite code',
    isInviteCode:'Invite code exists',
    directInviteCode:'Direct invite code',
    groupName:"groupName",
  },
  activeTemplate:{
    type:"Activity Type",
    url: "Release domain name",
    detail: "Module Template",
    field:"Ad Attributes",
    fieldTitle: "Attribute Name",
    fieldField: "Attribute Code",
    fieldType: "Attribute Type",
    text:"Text",
    img:"Picture",
    title:"Template Title",
    activeTime: "active time",
    author:"Publisher",
  },
  advertising:{
    advertisingStats: "Advertising statistics",
    key: "key",
    value: "value",
    type: "type",
    adverType: "adverType",
    adverId: "adverId",
    account: "account",
    exportAccount: "exportAccount",
    createTime:"createTime",
    name:"Name of advertising",
    platform:"Application platform",
    term:"The period of validity",
    accountType:"Account type",
    isActive:"active",
    userLevel:"Account level",
    aboutType:"Degree of conversion",
    position:"Advertising position",
    positionType:"AD types",
    channel:"channel",
    adverInfo:"Advertising for details",
    startTime:"The start time",
    endTime:"Effect of time",
    status:"state",
    carapace:"Vest bag",
    time:"To take effect",
    param:"Apply to the user",
    url:"To upload pictures",
    title:"The title",
    address:"address",
    content:"content",
    sort:"sort",
    simulation:"simulation",
    real:"real",
    demoCaseReal:"demoCaseReal",
    stats:"Advertising statistics",
    positionName:"Name of advertising position",
    accountId:"Account number",
    clickCount: "Click count",
    clickToOpenCount: "Click to open count",
    actionTime:"Action time",
    deleted: "Deleted",
  },
  analy:{
    dayActive:"Number of account activate in real-time of the day",
    dayReal:"Real account opened on the day",
    dayDemo:"Demo account opened on the day",
    dayRealDemo:"Real account+demo account opened on the day",
    in:"that",
    dayRealActive:"The number of accounts opened and activated on the day",
    weekActiveCount:"The number of activated on last 7 days",
    weekRealCount:"The Number of real accounts opened in last 7 days",
    weekDemoCount:"The Number of demo accounts opened in last 7 days",
    weekRealDemoCount:"The Number of real+demo accounts opened in last 7 days",
    realCount:"Real accounts",
    demoCount:"Demo accounts",
    realDemoCount:"Real+Demo accounts",
    averCount:"Working Day Average line",
    week0: "Sunday",
    week1: "Monday",
    week2: "Tuesday",
    week3: "Wednesday",
    week4: "Thursday",
    week5: "Friday",
    week6: "Saturday",
    dayActiveRate:"The ratio of channels for activated real-time on the day",
    dayRealRate:"The ratio of channels for real account real-time on the day",
    dayDemoRate:"The ratio of channels for demo account real-time on the day",
    dayRealDemoRate:"The ratio of channels for real+demo account real-time on the day",
    dayRealCount:"Real account opened real time on the day",
    dayDemoCount:"Demo account opened real time on the day",
    dayRealDemoCount:"Real+Demo account opened real time on the day",
    today:"Today",
    yesterday:"Yesterday",
    activeCount:"Activation Number",
  },
  smsType:{
    device:"Page side",
    type:"Verification code method",
    updateTime:"Change the time",
    modify:"Switching method"
  },
  emailTemplate:{
    emailTemplate:"Email template",
  	templateName:"Template name",
    title:"Email title",
    enabled:"Status",
    updateDate: 'Update date',
  },
  emailSend:{
    sendEmail:"Send email",
    title:"Email title",
    sendCount:"Send count",
    sucCount:"Success count",
    failCount:"Fail count",
    updateDate: 'Update date',
    sendType:"Send type",
    chooseTemplate:"Choose template",
    content:"Email content",
    receiver:"Receiver",
    uploadReceiver:"Upload receiver",
    emailList:"Email list",
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'1、Multiple mailboxes separated by English commas',
    uploadTip3:'2、Each upload will overwrite the previous mailbox',
    uploadTip4:'3、Each sending cannot exceed 5,000 mailboxes, and it can be sent multiple times if it exceeds',
    uploadTip5:'4、The email list only supports .txt or .csv file format',
    uploadTip6:'1、Attachment only supports .pdf file format',
    uploadTip7:'2、Each attachment cannot exceed 10MB in size',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    uploadFile:'Upload now',
    attachment:'Attachment',
    selectAttachment:'Select attachment',
    deleteAll:'Delete all',
    chooseChannel:"Choose channel",
    sender:"Sender",
    emailId: "(EN) 邮件ID",
    customerEmailAddress: "(EN) 客户邮箱号",
    actionDatetime: "(EN) 操作时间",
    emailStats: "(EN) 邮件数据统计",
    statsDetails: "(EN) 数据详情",
    openRate: "(EN) 打开率",
  },
  emailChannel:{
    emailChannel:"Email channel",
    channelName:"Channel name",
    emailAddress:"Email address",
    enabled:"Status",
    updateDate: 'Update date',
    senderName: "Sender Name",
    smtpHost: "SMTP Host",
    smtpPort: "SMTP Port",
    smtpUser: "SMTP User",
    smtpPassword: "SMTP Password"
  },
  optional:{
    iCodeId: "code",
    symbol: "symbol",
    platform: "platform",
    businessType: "businessType",
    accountNo: "accountNo",
    account: "account",
    createTime: "create Time",
    channel: "channel",
  },
};
